import { Switch, withStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

import { colors } from '../themes/colors';

export const ModSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: colors.blue6,
      '&:hover': {
        backgroundColor: alpha(colors.blue6, 0.15),
      },
    },
    '&$checked + $track': {
      backgroundColor: colors.blue6,
      backgroundOpacity: 0.8,
    },
  },
  checked: {},
  track: {},
})(Switch);
